module.exports = __webpack_public_path__ + "static/img/error_404.f8056f5e.png";